import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { take } from "rxjs/operators";
import { BaseService } from "../../core/services/default/base.service";

@Injectable({
  providedIn: "root",
})
export class LotsRegisterService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  isRegisteredBank() {
    return this.http.get(`${this.urlApi}/dados-bancarios`).pipe(take(1));
  }

  registerBank(body, bankId) {
    if (!body) return;
    body["accessId"] = Number(body.accessId);
    body["bankId"] = bankId;
    body["accountType"] = Number(body.accountType);
    body["bank"] = body.bank.split(" - ")[1];
    return this.http.post(`${this.urlApi}/dados-bancarios`, body).pipe(take(1));
  }
}
